
import Vue from 'vue';

import { CvToastNotification } from '@carbon/vue';

import { mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/product';

export default Vue.extend({
  name: 'ProductNotPrintableNotification',
  components: {
    CvToastNotification,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(useProductStore, ['isProductPrintable']),
  },
});
